if (!customElements.get('flask-inline-media')) {
  customElements.define('flask-inline-media', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const dialog = this.querySelector('.flask-zoom');
      const photos = [...this.querySelectorAll('[data-flask-zoom]')];
      const zoomImage = dialog.querySelector('img');
      const stage = dialog.querySelector('.flask-zoom-stage');
      const signal = this.abort.signal;
      let active = 0;
      let previousOverflow;
      const showPhoto = index => {
        active = (index + photos.length) % photos.length;
        dialog.classList.remove('is-magnified');
        stage.scrollTo(0, 0);
        zoomImage.alt = photos[active].querySelector('img').alt;
        zoomImage.src = photos[active].dataset.flaskZoom;
      };
      photos.forEach((button, index) => button.addEventListener('click', () => {
        showPhoto(index);
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      }, {signal}));
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.querySelector('[data-zoom-prev]').addEventListener('click', () => showPhoto(active - 1), {signal});
      dialog.querySelector('[data-zoom-next]').addEventListener('click', () => showPhoto(active + 1), {signal});
      let gesture = null;
      let suppressClickUntil = 0;
      let wheelTime = -Infinity;
      let wheelDistance = 0;
      let wheelUsed = false;
      stage.addEventListener('wheel', event => {
        if (!dialog.open || dialog.classList.contains('is-magnified') || event.ctrlKey ||
            (window.visualViewport?.scale || 1) > 1.05) return;
        const dx = event.deltaX || (event.shiftKey ? event.deltaY : 0);
        const dy = event.shiftKey && !event.deltaX ? 0 : event.deltaY;
        if (!dx || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
        event.preventDefault();
        const now = performance.now();
        if (now - wheelTime > 220) { wheelDistance = 0; wheelUsed = false; }
        wheelTime = now;
        if (wheelUsed) return;
        const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? stage.clientWidth : 1;
        wheelDistance += dx * unit;
        if (Math.abs(wheelDistance) >= 60) {
          showPhoto(active + (wheelDistance > 0 ? 1 : -1));
          wheelUsed = true;
          suppressClickUntil = now + 500;
        }
      }, {passive: false, signal});
      const pointers = new Set();
      stage.addEventListener('dragstart', event => event.preventDefault(), {signal});
      stage.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        pointers.add(event.pointerId);
        if (pointers.size !== 1) { gesture = null; suppressClickUntil = performance.now() + 500; return; }
        suppressClickUntil = 0;
        gesture = {id:event.pointerId, x:event.clientX, y:event.clientY, time:performance.now(),
          canSwipe:!dialog.classList.contains('is-magnified') && (window.visualViewport?.scale || 1) <= 1.05};
        if (gesture.canSwipe) stage.setPointerCapture(event.pointerId);
      }, {signal});
      stage.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>10) suppressClickUntil=performance.now()+500;
      }, {signal});
      stage.addEventListener('pointerup', event => {
        pointers.delete(event.pointerId);
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx=event.clientX-gesture.x, dy=event.clientY-gesture.y;
        if (Math.hypot(dx,dy)>10) suppressClickUntil=performance.now()+500;
        if (gesture.canSwipe && Math.abs(dx)>=50 && Math.abs(dx)>Math.abs(dy)*1.3 && performance.now()-gesture.time<1200) showPhoto(active+(dx<0?1:-1));
        gesture=null;
      }, {signal});
      stage.addEventListener('pointercancel', event => { pointers.delete(event.pointerId); gesture=null; suppressClickUntil=performance.now()+500; }, {signal});
      stage.addEventListener('lostpointercapture', () => { gesture=null; }, {signal});
      stage.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < suppressClickUntil) {
          event.preventDefault();
          return;
        }
        dialog.classList.toggle('is-magnified');
        stage.scrollTo(0, 0);
      }, {signal});
      dialog.addEventListener('close', () => {
        gesture = null; pointers.clear();
        wheelTime = -Infinity; wheelDistance = 0; wheelUsed = false;
        zoomImage.removeAttribute('src');
        dialog.classList.remove('is-magnified');
        document.body.style.overflow = previousOverflow || '';
        photos[active].focus({preventScroll: true});
      }, {signal});
      this.closeZoom = () => {
        if (dialog.open) {
          dialog.close();
          zoomImage.removeAttribute('src');
          document.body.style.overflow = previousOverflow || '';
        }
      };
      const grid = this.querySelector('.flask-photo-grid');
      const buttons = [...this.querySelectorAll('[data-photo-index]')];
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        grid.scrollTo({left: grid.children[index].offsetLeft - grid.children[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: this.abort.signal}));
      grid.addEventListener('scroll', () => {
        const index = Math.round(grid.scrollLeft / (grid.children[0].getBoundingClientRect().width + 12));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      }, {passive: true, signal: this.abort.signal});
    }
    disconnectedCallback() { this.closeZoom?.(); this.abort?.abort(); }
  });
}



